export default __webpack_public_path__ + "static/media/zw.1f332afd.svg";